export const brandSocials = (state = [], action: any) => {
    switch (action.type) {
        case 'SET_BRAND_SOCIALS':
            return action.socials
        default:
            return state
    }
}